import { Loader2Icon } from "lucide-react"

import { cn } from "@/lib/utils"

export interface SpinnerProps extends React.ComponentProps<"svg"> {
  /**
   * "brand"  — Nashid orange (#F97316), default.
   * "muted"  — muted-foreground gray, for subtle/secondary contexts.
   */
  variant?: "brand" | "muted"
}

function Spinner({ className, variant = "brand", ...props }: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn(
        "size-4 animate-spin",
        variant === "brand" ? "text-[#F97316]" : "text-muted-foreground",
        className,
      )}
      {...props}
    />
  )
}

export { Spinner }
